module.exports = __webpack_public_path__ + "img/zh-tw_get.d6458bd.png";